import React from "react";
import { cx } from "../../utils";
import { Button, ButtonProps } from "../Button/Button";

export function CardButton({ className, ...props }: Omit<ButtonProps, "variant" | "size">) {
  return <Button variant="ghost" size="none" className={cx("overflow-hidden rounded-xl bg-player-surface text-left transition-colors hover:bg-player-raised", className)} {...props} />;
}

export function Panel({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("min-w-0 border border-border bg-surface", className)} {...props} />;
}

export function OutlinedPanel({ title, className, children, tone = "accent" }: {
  title: string; className?: string; children?: React.ReactNode; tone?: "accent" | "neutral";
}) {
  return <div className={cx("relative min-h-[140px] w-full max-w-[480px] min-w-0 rounded-xl border-4", tone === "neutral" ? "border-control" : "border-panel-accent", className)}>
    <span className={cx("absolute -top-4 left-5 px-3 text-[2rem] font-medium leading-none max-[640px]:-top-2.5 max-[640px]:left-3 max-[640px]:px-2 max-[640px]:text-[1.15rem]", tone === "neutral" ? "bg-auth-end text-control" : "bg-panel text-panel-accent")}>{title}</span>
    <div className="min-h-[140px] p-6">{children}</div>
  </div>;
}
